// Mock data pour le site de Siriane Belliard-Reynes - Neuro Thérapie

import neuroVegetatifImg from './assets/images/system-neuro-vegetatif.png';
import endocrinienImg from './assets/images/system-endocrinien.png';
import inconscientImg from './assets/images/inconscient.png';
import emotionnelImg from './assets/images/emotionnel.png';
import heroImg from './assets/images/Hero.jpg';

export const methodSystems = [
  {
    id: 1,
    name: "Système Neuro-végétatif",
    image: neuroVegetatifImg,
    credit: { author: "Taychin Olanwichitwong", source: "Unsplash", url: "https://unsplash.com/photos/QFepbvTEmY8" },
    description: "La dystonie neuro-végétative est souvent la cause de nombreux symptômes, notamment la fatigue et l'irritabilité. Cela affecte le fonctionnement normal des systèmes sympathique et para-sympathique. Le réguler est donc d'une importance capitale."
  },
  {
    id: 2,
    name: "Système Endocrinien",
    image: endocrinienImg,
    credit: { author: "Markus Kammermann", source: "Unsplash", url: "https://unsplash.com/photos/pnPwc-Pffuk" },
    description: "Au cœur de cette technique se trouve la capacité régulatrice de nos huit glandes endocrines, aussi appelés huit merveilleux vaisseaux en médecine traditionnelle chinoise."
  },
  {
    id: 3,
    name: "Inconscient",
    image: inconscientImg,
    credit: { author: "Greg Rakozy", source: "Unsplash", url: "https://unsplash.com/photos/oMpAz-DN-9I" },
    description: "Chaque seconde de votre existence est inscrite dans le récit de votre histoire. Même refoulé, chaque événement participe à la construction de votre être et influence vos pensées, réactions et manières d'agir. Les identifier nous permettra de vous comprendre et de vous redonner le pouvoir du choix au lieu de subir."
  },
  {
    id: 4,
    name: "Émotionnel",
    image: emotionnelImg,
    credit: { author: "Louis Galvez", source: "Unsplash", url: "https://unsplash.com/photos/I8gQVrDcXzY" },
    description: "Bien qu'il existe de nombreux perturbateurs endocriniens, l'émotionnel reste une cause majeure des dérèglements hormonaux et, par conséquent, des maladies. Il est donc essentiel d'accueillir et de prendre en compte les émotions."
  }
];

export const sessionStats = [
  {
    label: "Durée moyenne d'une séance",
    value: "60 à 75 min"
  },
  {
    label: "Accompagnement personnalisé",
    value: "100%"
  },
  {
    label: "D'études, de recherches et de formation continue",
    value: "5 ans d'études et recherches"
  }
];

export const osteopathyPrinciples = [
  "Médecine traditionnelle chinoise",
  "Évaluation holistique des différents systèmes du corps",
  "Techniques manuelles douces adaptées à chaque personne",
  "Intégration des dimensions physique et émotionnelle",
  "Approche préventive pour maintenir l'équilibre à long terme"
];

export const kinesiologyContent = {
  title: "Comprendre la Kinésiologie",
  description: "La Kinésiologie est une méthode qui permet d'identifier précisément les causes des déséquilibres et propose des solutions adaptées grâce à des techniques d'évaluation et de rééquilibration.",
  detail: "Grâce au test des muscles nous pouvons interroger directement votre corps et votre inconscient afin de rétablir un équilibre entre tous les systèmes psycho-émotionnels, physiques et énergétiques permettant de retrouver un bien-être général.\nCes tests ne permettent pas d'établir un diagnostic ni de déterminer la cause d'une maladie.",
  benefits: [
    "Médecine traditionnelle chinoise",
    "Thérapie en toute neutralité et sans jugement",
    "Accompagnement pour se découvrir intérieurement et mieux se comprendre",
    "Accompagnement pour sortir de schémas répétitifs, compulsifs et addictifs",
    "Libération des stress physiques, émotionnels et énergétiques"
  ],
};

export const aboutSections = [
  {
    title: "Ma Pratique",
    text: "Ma pratique de la neuro thérapie repose sur une approche globale qui considère l'influence des systèmes nerveux et hormonaux, de l'inconscient, de l'épigénétique et d'autres facteurs sur l'ensemble du corps pour rétablir son harmonie naturelle."
  },
  {
    title: "Mon Approche",
    text: "Mon approche thérapeutique se concentre sur la restauration de l'équilibre corporel et psycho-émotionnel dans sa globalité. En identifiant les déséquilibres profonds, je travaille à réactiver les mécanismes naturels d'auto-régulation du corps."
  },
  {
    title: "Ma Méthodologie",
    text: "La neuro thérapie permet de rétablir par divers protocoles et corrections adaptées, un équilibre entre les différents systèmes du corps, favorisant ainsi sa capacité innée à maintenir un état d'équilibre et d'harmonie."
  },
  {
    title: "Formation Continue",
    text: "Je suis en formation continue pour toujours améliorer les prises en charge et approfondir les diverses connaissances sur le corps, la psychologie, l'influence du vécu sur notre santé et nos dérèglements.\nElle nourrit une pratique attentive aux besoins et aux limites de chacun."
  }
];

export const aboutBadges = [
  "Approche personnalisée",
  "Techniques modernes",
  "Équilibre corporel"
];

export const heroContent = {
  badge: "Neuro-thérapie & bien-être",
  title: "Votre corps vous parle, et si vous preniez enfin le temps de l'écouter ?",
  description: "Grâce à des techniques neuro-thérapeutiques douces, je vous aide à libérer les tensions, calmer le système nerveux et redonner de la fluidité à vos mouvements quotidiens.",
  ctaButton1: "Prendre rendez-vous",
  ctaButton2: "Découvrir ma méthode",
  features: [
    {
      title: "Approche globale",
      description: "Rééquilibrage du système nerveux et du corps dans son ensemble."
    },
    {
      title: "Accompagnement personnalisé",
      description: "Des séances adaptées à vos besoins et à votre rythme."
    },
    {
      title: "Méthodes douces",
      description: "Techniques respectueuses pour libérer les tensions durablement."
    }
  ],
  image: heroImg,
  quote: "Chaque séance est un pas supplémentaire vers un équilibre et une harmonie durable entre votre corps et votre esprit."
};

export const contactInfo = {
  address: {
    street: "9 rue du Docteur Mourier",
    city: "77430 Champagne-sur-Seine",
    mapsUrl: "https://maps.google.com/?q=9+rue+du+Docteur+Mourier+77430+Champagne-sur-Seine"
  },
  phone: {
    display: "06 36 14 31 26",
    link: "+33636143126",
    hours: "Du lundi au vendredi"
  },
  email: {
    address: "neuro.endo.therapeute@gmail.com",
    responseTime: "Réponse sous 48h"
  },
  schedule: {
    weekdays: "Du lundi au vendredi",
    weekend: "Weekend: Fermé"
  }
};

export const reasonsToConsult = [
  "Douleurs",
  "Trauma",
  "Libération des blocages",
  "Troubles du sommeil",
  "Stress et anxiété",
  "Schémas répétitifs dont vous ne parvenez pas à vous libérer",
  "Déséquilibres divers",
  "Gestion des émotions et de la colère",
  "Et bien d'autres sujets encore"
];

export const consultationInfo = {
  duration: "Entre 60 et 75 min",
  price: "70€",
  preparation: "Pour les séances d'ostéopathie neuro-endocrinienne, merci de venir avec une tenue adaptée. Un accès dégagé au dos et à la colonne vertébrale est indispensable. Prévoyez des sous-vêtements permettant une bonne accessibilité du dos.",
  note: "Consultation sur rendez-vous uniquement"
};

// Section photos du cabinet - À remplir avec de vraies photos
export const cabinetPhotos = [];

// Section eco credentials - À remplir si nécessaire
export const ecoCredentials = {
  title: "Un engagement pour votre bien-être",
  description: "Mon cabinet est conçu comme un espace de sérénité où chaque détail a été pensé pour vous permettre de vous recentrer et de vous reconnecter à votre corps.",
  details: "Des matériaux naturels, une ambiance apaisante et une approche respectueuse de votre rythme pour un accompagnement optimal.",
  partnerText: "Votre bien-être est ma priorité",
  images: {}
};

// Section tarifs
export const spotlightProducts = [
  {
    id: 1,
    name: "Séance Découverte",
    price: "70€",
    image: null
  },
  {
    id: 2,
    name: "Forfait 3 Séances",
    price: "195€",
    image: null
  },
  {
    id: 3,
    name: "Forfait 5 Séances",
    price: "315€",
    image: null
  }
];

// Section Instagram - À remplir avec de vraies photos
export const instagramPosts = [];
